import type { LegalPolicyKey } from "@/content/legal-policies";
import { normalizeCountryCode } from "@/lib/store-urls";

/** Operator home / missing country → locale cache only (no foreign extras). */
export const LEGAL_BASELINE_COUNTRY = "ES";

export type LegalAddendaPolicyNode = {
  content: string;
  contentSha256: string;
};

export type LegalCountryAddendaFile = {
  schemaVersion: number;
  country: string;
  locales: Partial<
    Record<string, Partial<Record<string, LegalAddendaPolicyNode>>>
  >;
};

/**
 * Country used to load a static overlay. Missing / invalid / ES → null
 * (locale cache already has ES baseline extras, which are none).
 */
export function resolveLegalOverlayCountry(
  country: string | null | undefined,
): string | null {
  const code = normalizeCountryCode(country);
  if (!code || code === LEGAL_BASELINE_COUNTRY) return null;
  return code;
}

export function overlayHtmlForPage(
  file: LegalCountryAddendaFile | null | undefined,
  locale: string,
  page: LegalPolicyKey,
): string {
  const html = file?.locales?.[locale]?.[page]?.content;
  return typeof html === "string" ? html : "";
}

/** Append a country overlay to the static locale snapshot. Pure — no fetch. */
export function composeLegalPolicyHtml(
  baselineHtml: string,
  overlayHtml: string | null | undefined,
): string {
  const extra = overlayHtml?.trim();
  if (!extra) return baselineHtml;
  if (baselineHtml.includes(extra)) return baselineHtml;
  return `${baselineHtml}\n${extra}`;
}
